import { render, staticRenderFns } from "./TabFAQView.vue?vue&type=template&id=34ab0024"
import script from "./TabFAQView.vue?vue&type=script&lang=ts"
export * from "./TabFAQView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports